<template>
    <div>
        <div class="big-title">
            <span>添加监测项目</span>
        </div>
        <a-row type="flex">
            <a-col flex="50px">

            </a-col>
            <a-col flex="auto">
                <a-row :gutter="4">
                    <a-col :span="5">
                        <span class="list-header">监测项目名称</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="list-header">牵头单位</span>
                    </a-col>
                    <a-col :span="3">
                        <span class="list-header">归属行业</span>
                    </a-col>
                    <a-col :span="7">
                        <span class="list-header">监测执行标准</span>
                    </a-col>
                    <a-col :span="2">
                    </a-col>
                </a-row>
                <a-row v-for="item in localValue" :gutter="4" :style="{margin:'12px'}">
                    <a-col :span="5">
                        <a-input v-model:value="item.taskName" placeholder="请填写项目名称"/>
                    </a-col>
                    <a-col :span="7">
                        <a-input v-model:value="item.leaderDw" placeholder="请选择牵头单位"/>
                    </a-col>
                    <a-col :span="3">
                        <a-input v-model:value="item.hangye" placeholder="请选择行业"/>
                    </a-col>
                    <a-col :span="7">
                        <a-input v-model:value="item.biaozhun" placeholder="请选择执行标准"/>
                    </a-col>
                    <a-col :span="2">
                        <a-button type="link" @click="removeItem(item)">删除</a-button>
                    </a-col>
                </a-row>
                <a-row>
                    <a-col :span="24">
                        <a-button type="link" icon="download" @click="addItem">
                            添加新监测项目
                        </a-button>
                    </a-col>
                </a-row>
            </a-col>
        </a-row>
    </div>
</template>

<script>
    import mixin from '../mixin/AExtArrayMixin'
    export default {
        name: "index",
        mixins:[mixin],
        data() {
            return {
                localValue: []
            }
        },
        methods:{
            addItem()
            {
                this.localValue.push({taskName:'',leaderDw:'',hangye:'',biaozhun:''});
            },
            removeItem(item)
            {
                this.localValue.remove(item);
            }
        }

    }
</script>

<style scoped>
    .list-header {
        color: #888888;
        font-weight: 700;
    }

    .big-title {
        color: #444444;
        font-weight: 700;
    }
</style>